<template>
  <div>
    <ts-input
      v-if="isCurrent"
      v-model="currentPage"
      size="mini"
      class="current-input"
      @change="handleCurrentInputKeypress"
    ></ts-input>
    <a v-else :class="pageClass" href="#" :aria-label="ariaPageLabel" @click="goToPage">
      {{ page }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.current-input::v-deep {
  .el-input__inner {
    width: 34px;
    height: 34px;
    padding: 0 !important;
    text-align: center;
  }
}
</style>

<script>
export default {
  name: 'TheSourcePagination2Page',
  props: {
    ariaPageLabel: {
      type: String,
      required: true
    },
    isCurrent: {
      type: Boolean,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    pageClass: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentPage: this.page
    };
  },
  computed: {
    currentClass() {
      return this.isCurrent ? 'c-sliding-pagination__page--current' : '';
    }
  },
  methods: {
    goToPage(e) {
      e.preventDefault();
      e.stopPropagation();

      this.$emit('page-click', this.page);
    },
    handleCurrentInputKeypress() {
      this.$emit('page-click', parseInt(this.currentPage));
    }
  }
};
</script>
